import React, { memo } from 'react';
import { Configuration, WebsiteEvent } from '../../resources/modelTypes';
import { formatAddress } from '../../events/utils';
import EventDetail from '../../events/website/EventDetail';
import {
  ActionLink, EventContainer, SmallHeadline,
} from '@minted/fancyclothes';
import { ThemedRichText } from './section-types/ThemedRichText';
import { css } from '@emotion/react';
import { theme } from '@minted/minted-components';

const displayEventStyles = {
  title: css`
    margin-top: ${theme.spacing.x8};
  `,
};

export type DisplayEventProps = {
  configuration: Configuration,
  event: WebsiteEvent,
}

const DisplayEvent = ({
  event,
}: DisplayEventProps) => {
  const formattedAddress = event.hasPhysicalAddress
    ? formatAddress(event)
    : '';
  const {
    date,
    description,
    endDate,
    endTime,
    hasPhysicalAddress,
    time,
    title,
    venue,
  } = event;

  return (
    <div>
      <div>
        <div css={displayEventStyles.title}>
          <EventContainer>
            <SmallHeadline>
              {title}
            </SmallHeadline>
          </EventContainer>
        </div>
        <div>
          <EventDetail
            address={formattedAddress}
            date={date}
            endDate={endDate}
            endTime={endTime}
            time={time}
            venue={venue}
          />

          {description && <ThemedRichText content={description} />}

          {
            hasPhysicalAddress && (
              <ActionLink
                target="_blank"
                text="Get Directions"
                url={
                  'https://www.google.com/maps/dir/?api=1&destination='.concat(
                    encodeURIComponent(formattedAddress),
                  )
                }
              />
            )
          }
        </div>
      </div>
    </div>
  );
};

const MemoizedDisplayEvent = memo(DisplayEvent);

export { MemoizedDisplayEvent as DisplayEvent };
